import $ from 'jquery'
import mobileMenu from './mobileMenu';

let header;
let headerMenu;
let headerNav;
let searchTrigger;
let body;
let scrollPos = 0;
let scrollDiff = 0;

const initHeaderScroll = function() {
	$(window).on('scroll',function() {
		let st = $(window).scrollTop();
		if(st < 0)st = 0;
		if(st > $(window).height() * 0.25) {
            if(header.hasClass('hover')) return;
			if(!header.hasClass('scrolled')) {
				header.addClass('noshow');
				setTimeout(function() {
					header.removeClass('noshow');
				},10);
			}
			header.addClass('scrolled');
		} else {
			header.removeClass('scrolled');
		}
		if(st < scrollPos) {
			if( scrollDiff > 0 ) {
				scrollDiff = 0;
			}
			scrollDiff += (st - scrollPos);
		} else {
			scrollDiff = st - scrollPos;
		}
        if(scrollDiff < -80 && !window.hideHeader) {
            header.addClass('show');
        } else if(scrollDiff > 0) {
            header.removeClass('show');
        }
        body.toggleClass('scrolled',header.hasClass('scrolled'));
		scrollPos = st;
	});
}

const initHeaderHover = function() {
    headerMenu.find('li.arrow').on('mouseenter',function(event) {
        header.addClass('hover');
    });
    headerMenu.parent().on('mouseleave',function(event) {
        header.removeClass('hover');
        $(window).trigger('scroll');
    });
    headerNav.find('[data-close]').on('click',function(event) {
        header.removeClass('hover');
        $(window).trigger('scroll');
    });
}

const initHeaderHeight = function() {
    var setVar = function() {
        var hh = header.outerHeight();
        document.documentElement.style.setProperty('--header-height',`${hh}px`);
    }
    $(window).on('resize',setVar);
    setVar();
}

const initSearch = function() {
    searchTrigger.on('click', function() {
        header.toggleClass('search-active');
        if(header.hasClass('search-active')) {
            header.find('input[type="search"]').focus();
        }
    });
    const mobileSearch = header.find('.header__mobile-search');
    
    mobileSearch.find('form').on('submit',function(e) {
        var s = mobileSearch.find('input').val();
        if(!s) {
            e.preventDefault();
            header.removeClass('search-active');
        }
    })
    body.on('click', function(e) {
        var target = $(e.target);
        var searchEl = target.closest('.header__search-trigger,.header__mobile-search');
        if(!searchEl.length) {
            
            header.removeClass('search-active');
        }
    });
}


export default {
	init: function() {
		header = $('.header');
        headerMenu = $('.header__menu');
        headerNav = $('.header__nav');
        searchTrigger = $('.header__search-trigger');
        body = $('body');
		initHeaderScroll();
        initHeaderHover();
        //initHeaderHeight();
        initSearch();
	},
}
